module.exports = __webpack_public_path__ + "img/1.5827169f.jpg";